/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick, CloudObject } from 'olympe';
import {getLogger} from "@olympeio/core";
import {setHistorizedState} from "./WorkflowGetHistoryAtDate";
import {combineLatest} from "rxjs";
import { queryHistoryAtState } from './_workflow';

export default class WorkflowGetHistoryAtState extends Brick {

    /**
     * @override
     */
    setupExecution($) {
        // Accept to propagate null
        return combineLatest(this.getInputs().map(i => $.observe(i)));
    }

    /**
     * @protected
     * @param {!BrickContext} $
     * @param {CloudObject} object
     * @param {string} state
     * @param {function(*)} setStateObject
     * @param {function(String)} setState
     * @param {function(Date)} setDate
     * @param {function(String)} setAssignee
     * @param {function(*)} setHistorizedObject
     */
    update($, [object, state], [setStateObject, setState, setDate, setAssignee, setHistorizedObject]) {
        // If the object or the workflow becomes null, propagate the info
        if (object === null || state === null ) {
            getLogger('Get history at state').error('No object or state specified');
            setStateObject(null);
            setState(null);
            setDate(null);
            setAssignee(null);
            setHistorizedObject(null);
        } else {
            queryHistoryAtState(object, state)
                .observe($)
                .subscribe((result) => {
                    setHistorizedState(result.getFirst(), setStateObject, setState, setDate, setAssignee, setHistorizedObject);
                });
        }
    }
}

registerBrick('0181720aca87ff5378fd', WorkflowGetHistoryAtState);
